interface TabDef<T extends string> {
  id: T
  label: string
  icon: React.ReactNode
}

export function Tabs<T extends string>({
  tabs,
  active,
  onChange,
}: {
  tabs: TabDef<T>[]
  active: T
  onChange: (id: T) => void
}) {
  // REVIEW_v1.md M5: a single scrolling row hid tabs past the panel's edge
  // with no visible scrollbar/affordance (found at width 1280 AND at the
  // narrowest tested width — not just a rare small-viewport edge case).
  // Wrapping to as many rows as needed keeps every tab always visible and
  // clickable with no scroll/hidden state, at the cost of a taller tab bar.
  return (
    <div className="flex flex-wrap border-b border-ink-border shrink-0" role="tablist">
      {tabs.map((t) => (
        <button
          key={t.id}
          role="tab"
          aria-selected={active === t.id}
          data-tab={t.id}
          onClick={() => onChange(t.id)}
          className={`flex flex-col items-center gap-1 px-3 py-2 text-[10px] basis-1/4 grow border-b-2 transition-colors ${
            active === t.id
              ? 'border-accent-blue text-text'
              : 'border-transparent text-text-faint hover:text-text-muted'
          }`}
        >
          {t.icon}
          {t.label}
        </button>
      ))}
    </div>
  )
}

export type { TabDef }
